module.exports = __webpack_public_path__ + "static/media/14UNEP5.88bcca29.jpg";